import { Fragment } from "react";
import {
  AuthContextProps,
  SettingsContextProps,
} from "../../../shared/data/types";
import { HomeDashboardFinancings } from "./HomeDashboardFinancings";
import { HomeDashboardFinancingsMarketplace } from "./HomeDashboardFinancingsMarketplace";
import "./HomeDashboardTabFinancing.scss";

interface HomeDashboardTabFinancingProps {
  settingsCtx: SettingsContextProps;
  auth: AuthContextProps;
  fetchId: string;
}

export const HomeDashboardTabFinancing = (
  props: HomeDashboardTabFinancingProps
) => {
  const { settingsCtx, auth, fetchId } = props;
  const isMarketplace = auth.activeModules?.includes("Marketplace");

  return (
    <Fragment>
      {auth.whitelabel !== "SERRANA" && !isMarketplace && (
        <HomeDashboardFinancings
          settingsCtx={settingsCtx}
          auth={auth}
          fetchId={fetchId}
        />
      )}
      {auth.whitelabel !== "SERRANA" && isMarketplace && (
        <HomeDashboardFinancingsMarketplace
          settingsCtx={settingsCtx}
          auth={auth}
          fetchId={fetchId}
        />
      )}
    </Fragment>
  );
};
